import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { FlashMapComponent } from 'flash-map';
import {
  MapNoteModalViewComponent,
  NoteDraftChangedEvent,
  NoteFlushRequestedEvent,
} from '@/app/views/modals/map-note-modal/map-note-modal';

export type { NoteDraftChangedEvent, NoteFlushRequestedEvent };

type NoteModalApi = {
  noteOpen: () => boolean;
  noteText: () => string;
  noteSubtitle: () => string;
  activeNoteNodeId: () => string | null;
  onNoteClose: () => void;
  onNoteTextChange: (text: string) => void;
};

@Component({
  selector: 'app-map-note-modal',
  imports: [MapNoteModalViewComponent],
  templateUrl: './map-note-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapNoteModalComponent {
  readonly flashMap = input<FlashMapComponent | null>(null);
  readonly noteDraftChanged = output<NoteDraftChangedEvent>();
  readonly noteFlushRequested = output<NoteFlushRequestedEvent>();
  protected readonly panel = computed<NoteModalApi | null>(() => {
    const flashMap = this.flashMap();
    if (!flashMap) {
      return null;
    }
    return flashMap as unknown as NoteModalApi;
  });

  onNoteDraftChanged(event: NoteDraftChangedEvent): void {
    this.panel()?.onNoteTextChange(event.text);
    this.noteDraftChanged.emit(event);
  }

  onNoteFlushRequested(event: NoteFlushRequestedEvent): void {
    this.noteFlushRequested.emit(event);
  }

  onCloseRequested(): void {
    this.panel()?.onNoteClose();
  }
}
